import { styled } from '@paid-ui/ui';

export const EnvRibbon = styled('div', {
  'display': 'none',
  'position': 'fixed',
  'top': '10px',
  'right': '-30px',
  'padding': '2px 36px',
  'fontSize': '10px',
  'lineHeight': '14px',
  'fontWeight': '$bold',
  'letterSpacing': '0.5px',
  'textTransform': 'uppercase',
  'textAlign': 'center',
  'color': 'white',
  'transform': 'rotate(45deg)',
  'userSelect': 'none',
  'pointerEvents': 'none',
  'zIndex': '$navbar',
  '@md': {
    display: 'block',
  },

  'variants': {
    env: {
      local: {
        backgroundColor: '$pink',
      },
      dev: {
        backgroundColor: '$pink',
      },
      sit: {
        backgroundColor: '$blue',
      },
      uat: {
        backgroundColor: '$payInGreen',
      },
      prod: {
        display: 'none',
      },
    },
  },
});
